import { Component, Input, OnInit } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

const KEY = 'dossier-rdv-accompagnants'

@Component({
  selector: 'atyl-dossier-rdv-accompagnants',
  templateUrl: './dossier-rdv-accompagnants.component.html',
  styleUrls: ['./dossier-rdv-accompagnants.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-rdv-accompagnants',
  key: KEY,
})
export class DossierRdvAccompagnantsComponent implements OnInit {

  expanded: boolean = true;
  @Input() accompagnants: any[] = [];
  @Input() tiers: any
  @StringableValues(KEY) strings: any

  constructor() { }

  ngOnInit() {
  }

}
